import React from 'react'
import { Skeleton, Paper } from '@mui/material';
import RequestsHotelsCard from './RequestsHotelsCard.jsx';
import RequestsHotelsCardSimple from './RequestsHotelsCardSimple.jsx';
import RequestsHotelsPipelineContent from './RequestsHotelsPipelineContent.jsx';
import RequestsHotelsCalendar from './RequestsHotelsCalendar.jsx';
import NoResultCard from '../../common/NoResultCard.jsx';
import LoadMoreLoader from '../../common/LoadMoreLoader.jsx';
import TableLoader from '../../common/TableLoader.jsx';
import StatsSalesTable from '../stats/sales/StatsSalesTable.jsx';
import { backYouTheme } from '../../../../theme';
import { styled } from '@mui/material/styles';

const Panel = styled(Paper)({
    backgroundColor: backYouTheme.palette.secondary.main
});

export default function RequestsHotelsList(props){
	const {
		from,
		isLoaded = false,
		view,
		requestsHotels,
		max,
		constructParams,
		handleMonthChange,
		parameters,
		showTitle,
		showManager,
		showBudget,
		badgeBgColor,
		handleLoadMore,
		columnDef = {},
		columnVisibility = {},
		columnOrder = [],
		onChangeColumnVisibility = () => false
	} = props
	
	const [tableLoader, setTableLoader] = React.useState(true);
	React.useEffect(() => {
        setTableLoader(!isLoaded || !requestsHotels?.length);
    }, [requestsHotels]);

	let loadingContent = '';
	let content = '';
	switch (view) {
		case 'block':
			loadingContent = 
				<div className="row">
					{Array(5).fill(0).map((e, index) => 
						<div key={index} className="col-12 mb-3">
							<Skeleton className="card bg-gc-light-blue-dark border-none" variant="rectangular" width="100%" height={212} />
						</div>
					)}
				</div>;
			content = requestsHotels?.map((e, index) => 
				<RequestsHotelsCard
					key={e.requests_hotels.id}
					request={e.requests}
					id={e.requests_hotels.id}
					img={e.hotels.img}
					title={e.membres.display_name}
					requestsDate={e.requests_hotels.date_activated}
					checkin={e.requests_hotels.checkin ?? e.requests.checkin}
					checkout={e.requests_hotels.checkout ?? e.requests.checkout}
					accommodation={e.requests.nb_pax_total > 0 ? true : false}
					status={e.requests_hotels.status_requests_hotels}
					hotel={e.hotels.title}
					refRequest={e.requests.id}
					refHotel={e.requests_hotels.ref_hotel}
					refCustomer={e.requests.ref_client}
					requests={e.requests}
					segment={e.segmentations.label}
					nbView={e.requests_hotels.nbvueuser}
					lastView={e.requests_hotels.vuuser}
					lastViews={{
						client: {
							last: e.requests_hotels.vuuser,
							nb: e.requests_hotels.nbvueuser
						},
						hotelier: {
							last: e.requests_hotels.vuhotelier,
							nb: e.requests_hotels.nbvuehotelier
						}
					}}
					conseiller={e.conseiller_requests}
					requestManager={e.manager_requests}
					manager={e.manager}
					task={e.tasks}
					note={e.requests.comment}
					customer={e.membres}
					finalClient={e.final_client}
					societe={e.requests_societes}
					echeancier={e.payment_echeancier}
					products_orders={e.products_orders}
					totalHt={
						e.products_orders.total_ht && e.products_orders.total_ht != '' ? 
						e.products_orders.total_ht
						: 
						(e.requests.budget_without_commission.total != '' ? e.requests.budget_without_commission.total : 0)
					}
					totalPayed={e.payment_echeancier.total_payed > 0 ? e.payment_echeancier.total_payed : 0}
					devise={e.devises.symbol}
					hasFunctionSheets={e.requests_hotels.has_function_sheets}
					connectivityInfos={e.connectivity_infos}
					hasQuote={e.products_orders.total_ht && e.products_orders.total_ht != '' ? true : false}
					badge={e.badge}
					buttonDetails={e.button_details}
					commission={{
						status: e.requests_hotels.commission_status,
						rate: e.requests_hotels.commission_rate
					}}
					hasModeration={e.requests_hotels.has_moderation}
					frameworkAgreement={e.framework_agreements}
					dateActivated={e.requests_hotels.date_activated}
					prioritySlug={e.requests_hotels.status_priority_slug}
				/>
			)
			break;

		case 'list':
			loadingContent = 
				<div className="row">
					{Array(10).fill(0).map((e, index) => 
						<div key={index} className="col-12 mb-3">
							<Skeleton className="card bg-gc-light-blue-dark border-none" variant="rectangular" width="100%" height={108.84} />
						</div>
					)}
				</div>;
			content = requestsHotels?.map((e, index) => 
				<RequestsHotelsCardSimple
					key={e.requests_hotels.id}
					request={e.requests}
					id={e.requests_hotels.id}
					img={e.hotels.img}
					title={e.membres.display_name}
					requestsDate={e.requests_hotels.date_activated}
					checkin={e.requests_hotels.checkin ?? e.requests.checkin}
					checkout={e.requests_hotels.checkout ?? e.requests.checkout}
					accommodation={e.requests.nb_pax_total > 0 ? true : false}
					status={e.requests_hotels.status_requests_hotels}
					hotel={e.hotels.title}
					refRequest={e.requests.id}
					refHotel={e.requests_hotels.ref_hotel}
					refCustomer={e.requests.ref_client}
					requests={e.requests}
					type={e.requests.type_of_request}
					segment={e.segmentations.label}
					lastViews={{
						client: {
							last: e.requests_hotels.vuuser,
							nb: e.requests_hotels.nbvueuser
						},
						hotelier: {
							last: e.requests_hotels.vuhotelier,
							nb: e.requests_hotels.nbvuehotelier
						}
					}}
					conseiller={e.conseiller}
					requestManager={e.requests_managers}
					manager={e.manager}
					customer={e.membres}
					societe={e.requests_societes}
					devise={e.devises.symbol}
					connectivityInfos={e.connectivity_infos}
					showTitle={showTitle}
					showManager={showManager}
					showBudget={showBudget}
					badgeBgColor={badgeBgColor}
					echeancier={e.payment_echeancier}
					totalHt={
						e.products_orders.total_ht && e.products_orders.total_ht != '' ? 
						e.products_orders.total_ht
						: 
						(e.requests.budget_without_commission.total != '' ? e.requests.budget_without_commission.total : 0)
					}
					totalPayed={e.payment_echeancier.total_payed > 0 ? e.payment_echeancier.total_payed : 0}
					badge={e.badge}
					frameworkAgreement={e.framework_agreements}
					dateActivated={e.requests_hotels.date_activated}
					prioritySlug={e.requests_hotels.status_priority_slug}
				/>
			)
			break;

		case 'stats':
			loadingContent = 
				<div className="row">
					<div className="col-12 mb-3">
						<Panel elevation={0} className="rounded-bottom rounded bg-gc-light-blue-dark p-2">
							<TableLoader />
						</Panel>
					</div>
				</div>;
			content = 
				<div className="col-12">
					<Panel elevation={0} className="rounded-bottom rounded bg-gc-light-blue-dark p-2">
						<StatsSalesTable
							isLoaded={isLoaded}
							tableLoader={tableLoader}
							columnDef={columnDef}
							columnVisibility={columnVisibility}
							columnOrder={columnOrder}
							data={requestsHotels}
							onColumnChange={(columns) => {
								setTableLoader(true);
								onChangeColumnVisibility(columns);
							}}
						/>
					</Panel>
				</div>;
		break;

		case 'pipeline':
			loadingContent = 
				<div className="row">
					<div className="col-12 mb-3">
						<Skeleton className="card bg-gc-light-blue-dark border-none" variant="rectangular" width="100%" height={'80vh'} />
					</div>
				</div>;
			content = <RequestsHotelsPipelineContent items={requestsHotels}/>;
			break;

		case 'calendar':
			loadingContent = 
				<div className="row">
					<div className="col-12 mb-3">
						<Skeleton className="card bg-gc-light-blue-dark border-none" variant="rectangular" width="100%" height={'80vh'} />
					</div>
				</div>;
			content = <div className="col-12">
					<div className={"card border-none bg-white" + (from != 'volet' ? " p-4" : "")}>
						<RequestsHotelsCalendar 
							items={requestsHotels}
							constructParamsFunction={constructParams}
							handleMonthChange={handleMonthChange}
							handleInitCalendar={handleMonthChange}
							parameters={parameters}
						/>
					</div>
				</div>;
			break;
	}

	return (
		<>
			{isLoaded || view == 'calendar' || (view == 'stats' && requestsHotels?.length > 0) ? (
					requestsHotels?.length > 0 || $.inArray(view, ['calendar', 'pipeline']) > -1 ? (
						$.inArray(view, ['calendar', 'pipeline']) > -1 ? (
							<div className="row">{content}</div>
						) : (
							<div>
								<div className="row">{content}</div>
								{/* <LoadMoreLoader
									next={handleLoadMore}
									hasMore={requestsHotels.length < max ? true : false}
								/> */}
							</div>
						)
					) : (
						<NoResultCard/>
					)
				) : loadingContent
			}
		</>
	);
}